/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:992px){.s-documents[_ngcontent-%COMP%]{position:relative;width:100%!important}}app-wizard-step[_ngcontent-%COMP%]   .main[_ngcontent-%COMP%]{max-width:100%}app-wizard-step[_ngcontent-%COMP%]   .spinner-cancel[_ngcontent-%COMP%]{margin:0 40%}@media (max-width:540px){.fixed-md[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
